import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Snackbar } from '@material-ui/core';

import HomeFooter from '../../components/Footer/HomeFooter/index.js';
import Header from '../../components/Header/index.jsx';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { ihutActions, ihutSelectors } from '../../redux/slices/ihut.ts';
import { logger } from '../../utils/logger.js';
import useSnackbar from '../../hooks/useSnackbar.ts';
import {
  AUTO_HIDE_DURATION,
  IHUT_FEATURE_KEY
} from '../../constants/common.js';
import SelectedActivityContent from './SelectedActivityContent/index.tsx';
import withFeatureEnabled from '../../hoc/withFeatureEnabled/index.tsx';

type Params = {
  id: string;
};

const SelectedProductActivity = () => {
  const { snackbarState, openSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation('ihut');
  const params = useParams<Params>();
  const dispatch = useAppDispatch();
  const activity = useAppSelector(ihutSelectors.selectSelectedActivity);

  useEffect(() => {
    if (activity && activity.supportRequested) {
      dispatch(ihutActions.getIhutSupportRequest())
        .unwrap()
        .catch((err) => {
          logger.error('Error getting support request', err);
          openSnackbar(
            err?.message || t('somethingWentWrong', { ns: 'common' })
          );
        });
    }
    if (!activity) {
      const activityId = params.id;
      dispatch(ihutActions.getIhutProjectDetails(activityId))
        .unwrap()
        .catch((err) => {
          logger.error('Error getting project details', err);
          openSnackbar(
            err?.message || t('somethingWentWrong', { ns: 'common' })
          );
        });
    }
  }, [activity, params.id]);

  useEffect(() => {
    return () => {
      dispatch(ihutActions.resetSelectedActivity());
    };
  }, []);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        message={snackbarState.message}
        autoHideDuration={AUTO_HIDE_DURATION}
        onClose={closeSnackbar}
      />
      <Header user="S" infoBanner />
      <SelectedActivityContent />
      <HomeFooter />
    </div>
  );
};

export default withFeatureEnabled(SelectedProductActivity, IHUT_FEATURE_KEY);
